var tw = tw || {};
tw.ConditionReportsListings = (function () {

	var _log = false,
		basePath = decodeURIComponent($("[data-basepath]").data("basepath")),
        $reports = $('.js-reports'),
		$toolbarSecondaryButtons = $('.js-toolbar-secondary-button'),
		maxDetailsItems = 3,
		strYoutubePin = 'YouTube Pin',
		imgBaseUrl = '',//"http://www.travelwisconsin.com",
		locationPhotosArray = Array(),
		weatherIcons = null,
		initUgc = true,
		reportTypeEnum = tw.ConditionsReports.getReportTypeEnum(),
		reportType = tw.ConditionsReports.getReportType(),
		reportSubcode = tw.ConditionsReports.getReportSubcode(),
		baseCategory,// = tw.ConditionsReports.getBaseCategory(),
		initUgc = true,
		isSnowReport = (reportType == "snowmobile" || reportType == 'crosscountry' || reportType == 'downhill') ? true : false,

		arrParentRegions = [{
				title: 'Northern',
				regions: ['northwest', 'northeast']
			},
			{
				title: 'Central',
				regions: ['central', 'east central']
			},
			{
				title: 'Southern',
				regions: ['southwest', 'south central', 'southeast']
			}
		],

		nearByType = {
			ACTIVITIES: "Activities",
			//DINING: "Dining",
			EVENTS: "Events",
			//LODGING: "Accommodations"
		},


		//templates
		activitiesNearbyTemplate = $('#activitiesNearbyTemplate').html(),
		//eventsNearbyTemplate = $('#eventsNearbyTemplate').html(),
		reportDetailsFCRTemplate = $('#reportDetailsFCRTemplate').html(),
		reportDetailsSCRTemplate = $('#reportDetailsSCRTemplate').html(),
		reportDetailsTrailTemplate = $('#reportDetailsTrailTemplate').html(),
		locationPhotoTemplate = $('#locationPhotoTemplate').html(),
		preloaderTemplate = $('#preloaderTemplate').html(),
		reportsAllHeadTemplate = $('#reportsAllHeadTemplate').html(),
		reportsAllBodyFCRTemplate = $('#reportsAllBodyFCRTemplate').html(),
		reportsAllBodySCRTemplate = $('#reportsAllBodySCRTemplate').html(),
		reportsAllBodyTrailTemplate = $('#reportsAllBodyTrailTemplate').html(),
		weatherCurrentNearbyTemplate = $('#weatherCurrentNearbyTemplate').html(),
		weatherForecastNearbyTemplate = $('#weatherForecastNearbyTemplate').html(),
		noReportsTemplate = $('#noReportsTemplate').html(),
		// snowReportCalloutBikingTemplate = $('#snowReportCalloutBikingTemplate').html(),
		reportPhotosTemplate = $('#reportPhotosTemplate').html(),
		//Can't append a non-closed tag
		reportsOLOpenTemplate = '<ol class="js-region-list list-unstyled m-0">',
		reportsOLCloseTemplate = '</ol>'
		;



		// if (_log) console.log('tw.ConditionReportsListings.reportTypeEnum: ', reportTypeEnum);

    var hideReports = function () {
		$reports.addClass('is-hidden');
	};

	var showReports = function () {
		// if (_log) console.log('showReports()');
        $reports.removeClass('is-hidden');
		tw.ConditionsReports.clearActive($toolbarSecondaryButtons);
		tw.ConditionsReports.setPaneRecords();
    };
    
    var showAllReports = function () {
		$('.js-reports-filter').prop('checked', false);
    };
    
    var isStatusFiltered = function () {
		var filtered = $('.js-reports-filter').is(":checked");

		return filtered;
    };
    
    var showReportSubpane = function (Id) {
		// if (_log) console.log('showReportSubpane().Id: ', Id);
		tw.ConditionsReports.clearActive($toolbarSecondaryButtons);
		//close any open subpanes
		tw.ConditionsReports.closeSubpanes();
        tw.ConditionsReports.openSubpane({ subpane: Id });
    };
    
    /**
	 * Main pane reports click anywhere to expand
	 */
	var expandReports = function (item) {
		var $this = item;
		var id = $this.data('id'),
			lat = $this.data('latitude'),
			lng = $this.data('longitude');
		if (_log) console.group('expandReports.js-report-expand.click()');
		if (_log) console.log('id: ', id);
		if (_log) console.log('lat: ', lat);
		if (_log) console.log('lng: ', lng);

		// if (_log) console.log('$(#infoboxText-' + id + ').width(): ', $('#infoboxText-' + id).width());
		if ($('#infoboxText-' + id).width() > 2) {
			// if (_log) console.log('LocalReports: infobox exists, expand it');
			BingMap.Map.infoBoxExpand(id);
		} else {
			// if (_log) console.log("setting openId to " + id);
			BingMap.Map.setOpenId(id);
			// if (_log) console.log('AllReports: center and zoom map, set openId, to open infobox upon creation openId:', id);
			BingMap.Map.centerZoomMap(lat, lng);
		}
		// if (_log) console.groupEnd();
	};
	

		/**
	 * Empty ReportDetails container div
	 */
	var emptyReportDetails = function () {
		// if(_log) console.log('emptyReportDetails()');
		$('#reportDetails').html('');
		$('#reportPhotos').html('');
		//$('#eventsNearby').html('');
		$('#activitiesNearby').html('');
		$('#weatherForecastNearby').html('');
		$('#snowReportCalloutBiking').html('');
	}


		/**
	 * Empty LocalReports container div
	 */
	var emptyLocalReports = function () {
		// if(_log) console.log('emptyLocalReports()');
		$('#reportsLocal').html('');
	}

	

	/**
	 * Get All Reports By Region
	 */
	var getAllReportsByRegion = function () {
		if (_log) console.log('getAllReportsByRegion()');

		baseCategory = tw.ConditionsReports.getBaseCategory();

		reportType = tw.ConditionsReports.getReportType();
		reportSubcode = tw.ConditionsReports.getReportSubcode();
		// if (_log) console.log('getAllReportsByRegion.reportType:::', reportType);
		// if (_log) console.log('getAllReportsByRegion.reportSubcode:::', reportSubcode);

		var compiledTemplate = Template7.compile(preloaderTemplate),
			htmlPreloader = compiledTemplate();
		$('#reportsAll').html(htmlPreloader);
		if (_log) console.log('getAllReportsByRegion.loadpreloader');

		$.ajax({
			url: basePath + '/getallreportsbyregion',
			data: {
				"reportType": reportType,
				"subcodeName": reportSubcode
			},
			type: "GET",
			success: function (data) {
				if (_log) console.log('getAllReportsByRegion.data.length:', data.length);
				addAllReportsByRegion(data,reportType);
			},
			error: function (xhr, status, error) {
				console.log(xhr, status, error);
			}
		});
	};


	
	/**
	 * Get Report Details
	 * @param {*} reportId 
	 */
	var getReportDetails = function (reportId, count) {
		if (_log) console.group('getReportDetails()');
		if (_log) console.log('reportId:', reportId);
		if (_log) console.log('count:', count);

		emptyReportDetails();
		var compiledTemplate = Template7.compile(preloaderTemplate),
			htmlPreloader = compiledTemplate(),
			reportType = tw.ConditionsReports.getReportType();
		$('#reportDetails').html(htmlPreloader);

		$.ajax({
			url: basePath + '/reportdetails',
			type: "POST",
			data: {
				id: reportId,
				reportType: reportType
			},
			success: function (data) {
				if (_log) console.log('getReportDetails.data: ', data);
				addReportDetails(data, count, reportType);
				// console.log(data, 'datagetReportDetails');
				// console.log(count, 'countgetReportDetails');
				// console.log(reportType, 'reportTypegetReportDetails');
				
			},
			error: function (xhr, status, error) {
				console.log(xhr, status, error);
			}
		});

		if (_log) console.log('reportType:', reportType);
		if (_log) console.groupEnd();
	};
	


	/**
	 * Add Report Details to Stage
	 * @param {*} data 
	 */
	var addReportDetails = function (data, count, reportType) {
		if (_log) console.log('addReportDetails()', data, count, reportType);

		BingMap.Map.setOpenId("");
		data.Count = count;

		var useTemplate;
		switch(reportType) {
			case reportTypeEnum.trail:
				useTemplate = reportDetailsTrailTemplate;
				break;
			case reportTypeEnum.fallcolor:
				useTemplate = reportDetailsFCRTemplate;
				break;
			default:
				useTemplate = reportDetailsSCRTemplate;
		}

		var compiledTemplate = Template7.compile(useTemplate);

		locationPhotosArray = [];
		//var arrImages = [];
		//console.log('data.Images.length:', data.Images.length);
		if (data.Images != null) {
			for (var i = 0; i < data.Images.length; i++) {
				//console.log('data.Images.i:', data.Images[i]);

				var prevId = (data.Images[i-1] != null) ? data.Images[i-1].Id : 0,
					nextId = (data.Images[i+1] != null) ? data.Images[i+1].Id : 0;
				//if (_log) console.log(prevId + ' < i(' + i + ') > ' + nextId);

				locationPhotosArray.push({
					Caption: data.Images[i].Caption,
					FileLocation: imgBaseUrl + data.Images[i].FileLocation,
					Id: data.Images[i].Id,
					MediaGalleryUrl: data.Images[i].MediaGalleryUrl,
					Name: data.Images[i].Name,
					Title: data.Title,//from parent, need to force it to model here,
					NextPhotoID: nextId,
					PreviousPhotoID: prevId
				});
			}
        }



		var gaShortHyphen = '';
		
		if (reportType == reportTypeEnum.trail) {
			if (reportSubcode && reportSubcode.trim() !== '') {
				gaShortHyphen = `- ${reportSubcode.charAt(0).toUpperCase()}${reportSubcode.slice(1)}`;
			}
		} else if (reportType != reportTypeEnum.fallcolor) {
			switch (reportType.toLowerCase()) {
				case 'downhill':
					gaShortHyphen = '- Downhill';
					break;
				case 'crosscountry':
					gaShortHyphen = '- Cross Country';
					break;
				case 'snowmobile':
					gaShortHyphen = '- Snowmobile';
					break;
				default:
					gaShortHyphen = reportType;
			}

		} else {
			gaShortHyphen = '- Fall Color';
		}	

		var fallColor = null;
		if(reportType == reportTypeEnum.fallcolor) {
			fallColor = BingMap.Map.getFallColorClass(data.PercentToPeak);
		}
		var headerImage = data.HeaderImage;
		var headerImageAltText = data.HeaderImageAltText;

		var percentToPeak = data.PercentToPeak;
		var percentToPeakStatus = percentToPeak + '%';
		if (data.PercentToPeak == 105) {
			percentToPeakStatus = 'Fading Peak';
		} else if (data.PercentToPeak == 110) {
			percentToPeakStatus = 'Until Next Year'
        }
		
		var openRuns = false;
		if (reportType == reportTypeEnum.downhill) {
			openRuns = data.OpenRuns;
		}

		var IsOpenClass = data.IsOpen ? 'Open' : 'Closed';

		var useTrailType = '';
		if(data.TrailType && data.TrailType != '') {
			useTrailType = data.TrailType.split(',').join(', ');
		}

		var useSurfaceType = '';
		if(data.SurfaceType && data.SurfaceType != '') {
			useSurfaceType = data.SurfaceType.split(',').join(', ');
		}

		var useRating = '';
		if(data.Rating && data.Rating != '') {
			useRating = data.Rating.split(',').join(', ');
		}

		var useConditionDescription = '';//coming soon
		if(data.ConditionDescription && data.ConditionDescription != '') {
			useConditionDescription = data.ConditionDescription;
		}

		var useOpen = '';
		if(data.Open != null && data.Open != '') {
			useOpen = data.Open;
		}
		if(data.OpenWinterFatBiking != null && data.OpenWinterFatBiking != 'Not Open for Winter Fat Biking') {
			useOpen = data.OpenWinterFatBiking;
			IsOpenClass = 'winterfat';
		}

		var activitiesAvailable = ''
		if(data.IsSkijoringAvailable){
			if(activitiesAvailable != '') activitiesAvailable += ', ';
			activitiesAvailable += 'Skijoring';
		}
		if(data.IsSnowshoeingAvailable){
			if(activitiesAvailable != '') activitiesAvailable += ', ';
			activitiesAvailable += 'Snowshoeing';
		}
		if(data.IsWinterFatBikingAvailable){
			if(activitiesAvailable != '') activitiesAvailable += ', ';
			activitiesAvailable += 'Winter Fat Biking';
		}

		var amenities = [];

		/*Downhill amenities*/
		if(data.AmenityAdaptiveProgram) {
			amenities.push('Adaptive Program');
		}
		if(data.AmenitySkiSchool) {
			amenities.push('Ski School');
		}
		if(data.AmenityLodge) {
			amenities.push('Lodge/Dining/Apres Ski');
		}
		if(data.AmenityNightSkiing) {
			amenities.push('Night Skiing');
		}
		if(data.AmenityLodging) {
			if(data.AmenityLodgingOnsite) {
				amenities.push('Lodging Onsite');
			}
			if(data.AmenityLodgingNearby5Miles) {
				amenities.push('Lodging within 5 miles');
			} 
			if(data.AmenityLodgingNearby10Miles) {
				amenities.push('Lodging within 10 miles');
			}
		}
		if(data.AmenityAdaptiveProgram) {
			amenities.push('Adaptive Program/Equipment');
		}
		if(data.AmenityTubing) {
			var desc = data.AmenityTubingDescription ? ': ' + data.AmenityTubingDescription : '';
			amenities.push('Tubing' + desc);
		}
		if(data.AmenityTicketPrice) {
			var desc = data.AmenityTicketPriceDescription ? ': ' + data.AmenityTicketPriceDescription : '';
			amenities.push('Standard Adult Lift Ticket Prices' + desc);
		}
		if(data.AmenityTicketPromo) {
			var desc = data.AmenityTicketPromoDescription ? ': ' + data.AmenityTicketPromoDescription : '';
			amenities.push('Lift Ticket Promos or Discounts' + desc);
		}

		/*Shared amenities*/
		if (data.AmenityEquipmentRentals) {
			amenities.push('Equipment Rentals');
		}

		/*Cross Country amenities*/
		if (data.AmenityWarmingShelterLodge) {
			amenities.push('Warming Shelter/Lodge');
		}
		if (data.AmenitySnowmaking) {
			amenities.push('Snowmaking');
		}
		if (data.AmenityLightedTrails) {
			amenities.push('Lighted Trails');
		}


		if(data.TrailMapLocation) {
			// console.log('data.TrailMapLocation:', data.TrailMapLocation);
			if(data.TrailMapLocation.slice(0,1) == '~'){
				// console.log('FOUND TILDE^^^ ');
				data.TrailMapLocation = data.TrailMapLocation.slice(1)
			}
		}

		var trailConditionLabel = (reportType == 'downhill') ? 'Overall Hill Condition' : 'Overall Trail Condition';
		var trailDescriptionLabel = (reportType == 'snowmobile') ? 'Trail Description' : 'About';

		var groomedFor = getGroomedFor(data);

		var jsonContent = {
			AddressFormatted: data.AddressFormatted,
			ActivitiesAvailable: activitiesAvailable,
			Amenities: amenities,
			Alert: (data.Alert != null) ? data.Alert : '',
			Base: (data.Base != null) ? data.Base : '',
			BikeType: (data.BikeType != null) ? data.BikeType : '',
			City: data.City,
			Condition: data.Condition,
			ConditionClass: BingMap.Map.getConditionBase(data.ConditionClass),
			Count: data.Count,
			CountyID: data.CountyID,
			County: data.County,
			ConditionDescription: useConditionDescription,
			Description: data.Description,
			Description2: data.Description2,
			Description3: data.Description3,
			Facebook: (data.Facebook != null) ? data.Facebook : '',
			FeeDetails: (data.FeeDetails != null) ? data.FeeDetails : '',
			FallColor: fallColor,
			GroomedFor: groomedFor,
			HasNoReporter: data.HasNoReporter,
			IsDNRTrail: data.IsDNRTrail,
			IsIceAgeTrail: data.IsIceAgeTrail,
			HeaderImage: data.HeaderImage,
			HeaderImageAltText: data.HeaderImageAltText,
			Hours: (data.Hours != null) ? data.Hours.replaceAll('\r\n', '<br/>') : '',
			Instagram: (data.Instagram != null) ? data.Instagram : '',
			IsFeeRequired: (data.IsFeeRequired != null) ? data.IsFeeRequired : '',
			IsOpen: data.IsOpen,
			IsOpenClass: IsOpenClass,
			IsGroomedForClassicSkiing: (data.IsGroomedForClassicSkiing != null) ? data.IsGroomedForClassicSkiing : '',
			IsGroomedForFatBiking: (data.IsGroomedForFatBiking != null) ? data.IsGroomedForFatBiking : '',
			IsGroomedForSkateSkiing: (data.IsGroomedForSkateSkiing != null) ? data.IsGroomedForSkateSkiing : '',
			IsSkijoringAvailable: (data.IsSkijoringAvailable != null) ? data.IsSkijoringAvailable : '',
			IsSnowshoeingAvailable: (data.IsSnowshoeingAvailable != null) ? data.IsSnowshoeingAvailable : '',
			IsWinterFatBikingAvailable: (data.IsWinterFatBikingAvailable != null) ? data.IsWinterFatBikingAvailable : '',
			ID: data.ID,
			Images: locationPhotosArray,
			Latitude: data.Latitude,
			Longitude: data.Longitude,
			LocationStatus: (data.LocationStatus != undefined && data.LocationStatus != null) ? data.LocationStatus : '',
			LocationUrl: (data.LocationUrl != '' && data.LocationUrl != 'http://') ? data.LocationUrl : '',
			ModifiedDate: data.ModifiedDate,
			MoreInfo: (data.MoreInfo != null) ? data.MoreInfo : '',
			Notices: (data.Notices != null) ? data.Notices : '',
			Open: useOpen,
			//OpenWinterFatBiking: (data.OpenWinterFatBiking != null) ? data.OpenWinterFatBiking : '',
			PercentToPeak: percentToPeak,
			PercentToPeakStatus: percentToPeakStatus,
			Phone: (data.Phone != null) ? data.Phone : '',
			Rating: useRating,
			Region: data.Region,
			RegionID: data.RegionID,
			RelatedLocation: data.RelatedLocation,
			ReportType: reportType,
			Runs: openRuns,
			SnowHotline: (data.SnowHotline != null) ? data.SnowHotline : '',
			State: (data.State != undefined && data.State != null) ? data.State : '',
			Subcode: (reportSubcode != null) ? reportSubcode.toLowerCase() : '',
			SurfaceType: useSurfaceType,
			Title: data.Title,
			TotalRuns: (data.TotalRuns != null) ? data.TotalRuns : '',
			TrailCondition: (data.TrailCondition != null) ? data.TrailCondition : '',//for SCR
			TrailConditionLabel: trailConditionLabel,//for SCR
			TrailType: useTrailType,
			TrailheadDirections: data.TrailheadDirections,
			TrailheadName: data.TrailheadName,
			TrailDescription: (data.TrailDescription != null) ? data.TrailDescription : '',//for SCR
			TrailDescriptionLabel: trailDescriptionLabel,//for SCR
			TrailInfo: (data.TrailInfo != undefined && data.TrailInfo != '' && data.TrailInfo != 'http://') ? data.TrailInfo : '',
			TrailNetwork: (data.TrailNetwork != null) ? data.TrailNetwork : '',
			TrailMapLocation: (data.TrailMapLocation != null) ? data.TrailMapLocation : '',
			Url: (data.Url != '' && data.Url != 'http://') ? data.Url : '',
			Website: data.Website,
            WeeksToPeak: data.WeeksOfPeak,
            WeeksToPeakName: data.WeeksToPeakName,
            YoutubeId: data.YoutubeId,
			gaShortHyphen: gaShortHyphen
		};
		// console.log(jsonContent, 'jsonContent')

		var html = compiledTemplate(jsonContent);
		$('#reportDetails').html(html);

		showReportSubpane('report-detail');

		tw.ConditionsReports.setPaneRecords('report-detail');

		BingMap.Map.Centering.SetQueryCenter(data.Latitude, data.Longitude);

		addReportPhotos(jsonContent);

		addActivitiesNearby(jsonContent, data.Title);
		// addSnowReportCalloutBiking(jsonContent, data.Title);
		//getEventsNearby(data.Latitude, data.Longitude, data.Title);
		//getActivitiesNearby(data.Latitude, data.Longitude, data.Title);




		// Call Geocode method only if latitude and longitude aren't present
		if(data.Latitude && data.Longitude)
		{
			getWeatherCurrentNearby(data.Latitude , data.Longitude, data.Title);
			getWeatherForecastNearby(data.Latitude , data.Longitude, data.Title);

		}else
		{
			getAllWeatherByGeocode(data.City, 'United States of America', data.title);
			// getAllWeatherByGeocode("Taiyuan", "China", data.title);
			// getAllWeatherByGeocode("Accrington", "England", data.title);
		}

		//console.log('data.UGCFeed:', data.UGCFeed);
		if (data.UGCFeed != null && data.UGCFeed != '') {
			initializeUGC(data.UGCFeed, 'reportPhotos');
		}

		setTimeout(() => {
			//console.log('******** scroll to top now **:', $('#reportDetails').closest('.pane').scrollTop());
			$('#reportDetails').closest('.pane').scrollTop(0);
		}, 100);

		//tw.Iterable.trackEvent({
		//	event: 'reportViewed', 
		//	name:  data.Title,
		//	city: data.City,
		//	report: (reportSubcode) ? reportSubcode : reportType
		//});
	}

	// /**
	//  * Add Report Weather Current nearby
	//  * @param {*} data 
	//  */
	// var addSnowReportCalloutBiking = function (data) {
	// 	// if (_log) console.group('reports.addSnowReportCalloutBiking()');
	// 	// if (_log) console.log('data:', data);
	// 	// if (_log) console.log('title:', title);
	// 	// if (_log) console.groupEnd();

	// 	// console.log(data.Subcode, 'data');
	// 	// console.log(data.IsOpenClass, 'data');

	// 	if(data.Subcode == "biking" && data.IsOpenClass == "winterfat") {
	// 		var html = '';

	// 		var compiledTemplate = Template7.compile(snowReportCalloutBikingTemplate);
	// 		html = compiledTemplate(data);
	// 		$('#snowReportCalloutBiking').html(html); 
	// 	}
	// }	

	
	/**
	 * Get Weather Current from lat/long
	 * 	https://openweathermap.org/forecast5
	*/
	var getWeatherCurrentNearby = function (latitude, longitude, title) {

		if (_log) console.group('reports.getWeatherCurrentNearby()');
		if (_log) console.log('latitude:::: ', latitude);
		if (_log) console.log('longitude: ', longitude);
		if (_log) console.log('title:', title);
		if (_log) console.groupEnd();

		tw.OpenWeather.getWeatherCurrentNearby(latitude, longitude)
			.then((res) => { 
				if (_log) console.log('reports.getWeatherCurrentNearby.res:', res);
				addWeatherCurrentNearby(res, title); 
			}) 
			.catch((err) => { 
				console.error(err); 
			}); 
	}



	/**
	 * Add Report Weather Current nearby
	 * @param {*} data 
	 */
	var addWeatherCurrentNearby = function (data, title) {
		// if (_log) console.group('reports.addWeatherCurrentNearby()');
		// if (_log) console.log('data:', data);
		// if (_log) console.log('title:', title);
		// if (_log) console.groupEnd();

		var html = '';

		var compiledTemplate = Template7.compile(weatherCurrentNearbyTemplate);
		html = compiledTemplate(data);
		$('#weatherCurrentNearby').html(html); 
	}

	var getWeatherForecastNearby = function (latitude, longitude, title) {
		// if (_log) console.group('reports.getWeatherForecastNearby()');
        // if (_log) console.log('latitude: ', latitude);
		// if (_log) console.log('longitude: ', longitude);
		// if (_log) console.log('title:', title);
		// if (_log) console.groupEnd();

		tw.OpenWeather.getWeatherForecastNearby(latitude, longitude, 4)
			.then((res) => { 
				//if (_log) console.log('reports.getWeatherForecastNearby.res:', res);
				addWeatherForecastNearby(res, title); 
			}) 
			.catch((err) => { 
				console.error(err); 
			}); 
	}



	/**
	 * Add Report Weather Forecast nearby
	 * @param {*} data 
	 */
	var addWeatherForecastNearby = function (data, title) {
		// if (_log) console.group('reports.addWeatherForecastNearby()');
		// if (_log) console.log('data:', data);
		// if (_log) console.log('title:', title);

		var html = '';

		$('#weatherForecastNearby').html('');
		var compiledTemplate = Template7.compile(weatherForecastNearbyTemplate);

		var json = {
			DisplayItems: data.displayItems,
			LocationTitle: title
		};

		html += compiledTemplate(json);
		$('#weatherForecastNearby').html(html);

		// if (_log) console.log('displayItems:', data.displayItems);
		// if (_log) console.groupEnd();
	}



	/**
	 * Get Weather Geocode
	 * 	https://openweathermap.org/geo
	*/
	var getAllWeatherByGeocode = function (city, country) {

		if (_log) console.group('reports.getAllWeatherByGeocode()');
		if (_log) console.log('city: ', city);
		if (_log) console.log('country: ', country);
		if (_log) console.groupEnd();

		tw.OpenWeather.getAllWeatherByGeocode(city, country)
			.then((res) => { 
				if (_log) console.log('reports.getAllWeatherByGeocode.res:', res);
				if(res.current) addWeatherCurrentNearby(res.current);
				if(res.forecast) addWeatherForecastNearby(res.forecast);
			}) 
			.catch((err) => { 
				console.error(err);
			}); 
	}


	/**
	 * Get Location Photo from ID
	 */
	var getLocationPhotoFromId = function (id) {
		if (_log) console.group('getLocationPhotoFromId()');
		if (_log) console.log('id:', id);
		if (_log) console.log('locationPhotosArray[]:', locationPhotosArray);
		var result = $.grep(locationPhotosArray, function(e){ 
			return e.Id == id;
		});

		if (_log) console.log('result:', result);
		if (_log) console.groupEnd();
		addLocationPhotoFromId(result);
	}

	var addLocationPhotoFromId = function (data) {

		var gaShortHyphen = '';

		if (reportType == reportTypeEnum.trail) {
			if (reportSubcode && reportSubcode.trim() !== '') {
				gaShortHyphen = `- ${reportSubcode.charAt(0).toUpperCase()}${reportSubcode.slice(1)}`;
			}
		} else if (reportType != reportTypeEnum.fallcolor) {
			switch (reportType.toLowerCase()) {
				case 'downhill':
					gaShortHyphen = '- Downhill';
					break;
				case 'crosscountry':
					gaShortHyphen = '- Cross Country';
					break;
				case 'snowmobile':
					gaShortHyphen = '- Snowmobile';
					break;
				default:
					gaShortHyphen = reportType;
			}

		} else {
			gaShortHyphen = '- Fall Color';
		}

		if (_log) console.log('addLocationPhotoFromId.data:', data);

		if (data.length == [0]){
			alert('could not find a match for that id');

		} else {
			var photo = data[0];
			var jsonContent = {
				gaShortHyphen: gaShortHyphen,
				Caption: photo.Caption,
				ImageSrc: photo.FileLocation,
				Id: photo.Id,
				MediaGalleryUrl: photo.MediaGalleryUrl,
				Name: photo.Name,
				Title: photo.Title,
				NextPhotoID: photo.NextPhotoID,
				PreviousPhotoID: photo.PreviousPhotoID
            }

			if (_log) console.log('jsonContent:', jsonContent);

            var compiledTemplate = Template7.compile(locationPhotoTemplate);

            var html = compiledTemplate(jsonContent);

            $('#locationPhoto').html(html);
            tw.ConditionsReports.openSubpane({ subpane: 'report-photo' });
			//alert('addLocationPhotoFromId jsonContent: ' + JSON.stringify(jsonContent));

		}
	}

	

	/**
	 * Add Report Photos
	 * This was retired for Crowdriff
	 */
    var addReportPhotos = function (json) {
        if (_log) console.log('addReportPhotos()', json);
        var compiledTemplate = Template7.compile(reportPhotosTemplate);
        var html = compiledTemplate(json);
        $('#reportPhotos').html(html);
	}


	
	/**
	 * Initialize User Generated Content
	 * 
	 * USE VANILLA JS FOR CROWDRIFF. USING JQUERY COMMANDS WILL BREAK PATHING SCOPE.
	 * $('#loaderUGC').append(s);//<--will break
	 * loaderUGC.append(s);//<--will also break on IE. use appendChild
	 * 
	 * @param {*} data 
	 * @param {*} divId 
	*/
	var initializeUGC = function (data, divId) {
		if (_log) console.log('initializeUGC()');
		if (_log) console.log('data:', data);
		if (_log) console.log('divId:', divId);

		if (!initUgc) {
			//If UGC has been initialized already, clear out the rendered array
			window.crowdriff__gallery.rendered = [];
		}
		$('#' + divId).html('');//clear out div

		var s = document.createElement("script");
		s.type = "text/javascript";
		s.src = "https://starling.crowdriff.com/js/crowdriff.js";
		s.id = data; //"cr-init__1b59e2be8c775f33"

		var UGCContainer = document.createElement("div");
		UGCContainer.classList.add("px-2");
		var loaderUGC = document.getElementById(divId);
		loaderUGC
			.appendChild(UGCContainer)
			.appendChild(s);

		if (!initUgc) {
			//If UGC has been initialized already, restart interval to process Queue
			//console.log('window.crowdriff__gallery.interval:', window.crowdriff__gallery.interval);
			if (window.crowdriff__gallery && !window.crowdriff__gallery.interval) {
				window.crowdriff__gallery.interval = setInterval(window.crowdriff__gallery.processQueue, 300);
			}
		}

		initUgc = false;
		if (_log) console.log('window:', window);
	}

	


	/**
	 * Add Report Activities nearby
	 * @param {*} data 
	 */
	var addActivitiesNearby = function (data, title) {
		//if (_log) console.log('addActivitiesNearby()', data, title);
		var compiledTemplate = Template7.compile(activitiesNearbyTemplate),
			mileRangeEvents = 10,
			mileRangeOther = 10,
			queryForAll = '&Keyword=&CategoryId=0&CurrentPage=1';


		if (data.RegionID != '') {
			queryForAll += '&RegionId=' + data.RegionID;
		} else {
			queryForAll += '&RegionId=0';
		}

		if (data.City != '') {
			queryForAll += '&City=' + data.City;// + '&CityId=14272';
		} else {
			queryForAll += '&City=';//&CityId=0
		}

		if (data.CountyID != '') {
			queryForAll += '&CountyID=' + data.CountyID;
		} else {
			queryForAll += '&CountyID=0';
		}
		if (data.County != '') {
			queryForAll += '&County=' + data.County;
		} else {
			queryForAll += '&County=0';
		}

		//http://localhost:49306/events#?CurrentPage=1&ContentPageId=561467&ContentPage_WidgetId=313970&BaseContentId=155342&Keyword=&StartDate=&EndDate=&CityId=15136&CountyId=908&City=Franklin&MileRange=25&CategoryId=0&RegionId=711&PageType=event

		//http://localhost:49306/things-to-do#directory?ContentPageId=561266&CurrentPage=1&ContentPage_WidgetId=313594&BaseContentId=86362&Keyword=&CityId=15136&City=Franklin&County=Milwaukee+County&CountyId=908&MileRange=25&CategoryId=0&RegionId=711&PageType=place

		//http://localhost:49306/dining#directory?ContentPageId=521677&CurrentPage=1&ContentPage_WidgetId=257808&BaseContentId=86372&Keyword=&CityId=15136&City=Franklin&County=Milwaukee+County&CountyId=908&MileRange=25&CategoryId=0&RegionId=711&PageType=place

		//http://localhost:49306/places-to-stay#directory?ContentPageId=561279&CurrentPage=1&ContentPage_WidgetId=313832&BaseContentId=86344&Keyword=&CityId=0&City=&County=&CountyId=0&MileRange=25&CategoryId=0&RegionId=711&PageType=place

		var json = {
			gaShortHyphen: data.gaShortHyphen,
			LocationTitle: title,
			urlEvents: '/events#?ContentPageId=561467&ContentPage_WidgetId=313970&BaseContentId=155342&PageType=event&MileRange=' + mileRangeEvents + queryForAll,
			urlThings: '/things-to-do#directory?ContentPageId=561266&ContentPage_WidgetId=313594&BaseContentId=86362&PageType=place&MileRange=' + mileRangeOther + queryForAll,
			urlDining: '/dining#directory?ContentPageId=521677&ContentPage_WidgetId=257808&BaseContentId=86372&PageType=place&MileRange=' + mileRangeOther + queryForAll,
			urlPlaces: '/places-to-stay#directory?ContentPageId=561279&ContentPage_WidgetId=313832&BaseContentId=86344&PageType=place&MileRange=' + mileRangeOther + queryForAll
		}
		
		//if (_log) console.log('addActivitiesNearby.json:', json);

		var html = compiledTemplate(json);
		$('#activitiesNearby').html(html); 

	}



	/**
	 * Add Report Details to Stage
	 * @param {*} data 
	 */
	var addAllReportsByRegion = function (data,reportType) {
		// if (_log) console.group('addAllReportsByRegion()');
		// if (_log) console.log('reportType', reportType);
		// if (_log) console.log('reportSubcode', reportSubcode);
		if (_log) console.log('tw.reports.addAllReportsByRegion.data', data);
		// if (_log) console.log('data.length', data.length);

		//if (_log) console.log('arrParentRegions.length: ' + arrParentRegions.length);

		$('#reportsAll').html('');

		var youtubeArr = [];
		var relatedPlacesArr = [];
		
		var useTemplateBody;
		switch(reportType) {
			case reportTypeEnum.trail:
				useTemplateBody = reportsAllBodyTrailTemplate;
				break;
			case reportTypeEnum.fallcolor:
				useTemplateBody = reportsAllBodyFCRTemplate;
				break;
			default:
				useTemplateBody = reportsAllBodySCRTemplate;
		}

		var useTemplateHead = reportsAllHeadTemplate,
			compiledTemplateHead = Template7.compile(useTemplateHead),
			compiledTemplateBody = Template7.compile(useTemplateBody);

		for (var r = 0; r < arrParentRegions.length; r++) {

			//ADD REGION HEADER, H2
			//if (_log) console.log('region...' + r + ': ' + arrParentRegions[r].title);
			var jsonContentHead = {
				ParentRegion: arrParentRegions[r].title
			};
			var htmlHead = compiledTemplateHead(jsonContentHead);
			$('#reportsAll').append(htmlHead);

			// OL OPENER TAG, can't append() an opening tag without a closing tag
			var htmlBody = reportsOLOpenTemplate;

			//LOOP THRU DATA LOOKING FOR MATCHES OF CURRENT REGION, ADD TO BODY
			for (var i = 0; i < data.length; i++) {
				//if (_log) console.log('data[i]:', data[i]);
				var curRegion = data[i].Region.toLowerCase(),
					pos = arrParentRegions[r].regions.indexOf(curRegion),
					isYoutubePin = (data[i].State == strYoutubePin || data[i].Condition == strYoutubePin) ? true : false;
					//isActive = data[i].IsActive;
				//if (_log) console.log('curRegion: ' + curRegion + ' <:in:> ' + arrParentRegions[r].regions);
				//if (_log) console.log('pos: ', pos);
				//if (_log) console.log('data[' + i + '].LocationStatus: ', data[i].LocationStatus);
				//if (_log) console.log('data[i].Title/isActive: ', data[i].Title, isActive);

				//used for toggle "status" button, status only exists for Snomobile tho, so use Condition instead

				data[i].IsYoutubePin = isYoutubePin;

				var filterOpen = false;
				
				
				// console.log(data[i].RelatedPlaces, 'relatedPaces');
				// Check if there are related places and add them to the relatedPlacesArr
				// if (data[i].RelatedPlaces && data[i].RelatedPlaces.length > 0) {
				// 	data[i].RelatedPlaces.forEach(function(relatedPlace) {
				// 		// Check if the related place is already in relatedPlacesArr based on .Name
				// 		var isDuplicate = relatedPlacesArr.some(function(existingPlace) {
				// 			return existingPlace.Name === relatedPlace.Name;
				// 		});

				// 		if (!isDuplicate) {
				// 			relatedPlacesArr.push(relatedPlace);
				// 		}
				// 	});
				// }
				// console.log(relatedPlacesArr, 'relatedPlacesArr');


				var conditionStatus = '';
				if (reportType == reportTypeEnum.trail) {
					// if (_log) console.log('******data[i].IsOpenWinterFatBiking:', data[i].IsOpenWinterFatBiking);
					if(data[i].IsOpenWinterFatBiking) {
						conditionStatus = 'winterfat';
					} else {
						conditionStatus = (data[i].IsOpen != null && data[i].IsOpen) ? 'open' : 'closed';
						//conditionStatus = (data[i].IsOpen) ? 'open' : 'closed';
					}

					filterOpen = conditionStatus == 'closed' ? false : true;

				} else if (reportType != reportTypeEnum.fallcolor) {
					conditionStatus = (data[i].Condition.toLowerCase() == 'closed') ? 'closed' : 'notclosed';
					filterOpen = conditionStatus == 'closed' ? false : true;

					// console.log(pos, 'pos');
					// console.log(isYoutubePin, 'isYoutubePin');
					if(pos >= 0 && isYoutubePin) {
						youtubeArr.push(data[i]);
					}

				} else {
					filterOpen = data[i].PercentToPeak >= 100 ? false : true;
				}


				var openRuns = false;
				if (reportType === reportTypeEnum.downhill) {// && data[i].RunsOpen !== undefined
					openRuns = data[i].RunsOpen;
                }

				var fallColor = null;
				if (reportType === reportTypeEnum.fallcolor) {// && data[i].RunsOpen !== undefined
					fallColor = BingMap.Map.getFallColorClass(data[i].PercentToPeak);
				}
				
				var percentToPeak = data[i].PercentToPeak;//
				var percentToPeakStatus = percentToPeak + '%';
				if (data[i].PercentToPeak == 105) {
					percentToPeakStatus = 'Fading Peak';
				} else if (data[i].PercentToPeak == 110) {
					percentToPeakStatus = 'Until Next Year'
                }

				var useTrailType = '';
				if(data[i].TrailType && data[i].TrailType != '') {
					useTrailType = data[i].TrailType.split(',').join(', ');
				}

				var useSurfaceType = '';
				if(data[i].SurfaceType && data[i].SurfaceType != '') {
					useSurfaceType = data[i].SurfaceType.split(',').join(', ');
				}

				var useRating = '';
				if(data[i].Rating && data[i].Rating != '') {
					useRating = data[i].Rating.split(',').join(', ');
				}

				var useOpen = '';
				if(data[i].Open != null && data[i].Open != '') {
					useOpen = data[i].Open;
				}
				if(data[i].OpenWinterFatBiking != null && data[i].OpenWinterFatBiking != 'Not Open for Winter Fat Biking') {
					useOpen = data[i].OpenWinterFatBiking;
				}

				var groomedFor = getGroomedFor(data[i]);

				var conditionId;
				switch(data[i].Condition) {
					case "Excellent":
						conditionId = 6;
						break;
					case "Good":
						conditionId = 5;
						break;
					case "Fair":
						conditionId = 4;
						break;
					case "Poor":
						conditionId = 3;
						break;
					case "Partially Open":
						conditionId = 2;
						break;
					default:
						//closed
						conditionId = 1;
						// with no report being 0
				}
				conditionId = (data[i].HasNoReporter) ? 0 : conditionId;

				
				if (pos >= 0 && !isYoutubePin) { //console.log('found match add to array');
					//if (_log) console.log('data[i].AmenityTubing:', data[i].AmenityTubing);
					//if (_log) console.log('percentToPeakStatus:', percentToPeakStatus);
					var jsonContentBody = {
						Alert: (data[i].Alert != null) ? data[i].Alert : '',
						AmenityAdaptiveProgram:  (data[i].AmenityAdaptiveProgram != null) ? data[i].AmenityAdaptiveProgram : false,
						AmenityEquipmentRentals:  (data[i].AmenityEquipmentRentals != null) ? data[i].AmenityEquipmentRentals : false,
						AmenityLightedTrails:  (data[i].AmenityLightedTrails != null) ? data[i].AmenityLightedTrails : false,
						AmenityLodge:  (data[i].AmenityLodge != null) ? data[i].AmenityLodge : false,
						AmenityLodging:  (data[i].AmenityLodging != null) ? data[i].AmenityLodging : false,
						AmenityNightSkiing:  (data[i].AmenityNightSkiing != null) ? data[i].AmenityNightSkiing : false,
						AmenitySkiSchool:  (data[i].AmenitySkiSchool != null) ? data[i].AmenitySkiSchool : false,
						AmenitySnowmaking:  (data[i].AmenitySnowmaking != null) ? data[i].AmenitySnowmaking : false,
						AmenityTicketPrice:  (data[i].AmenityTicketPrice != null) ? data[i].AmenityTicketPrice : false,
						AmenityTicketPromo:  (data[i].AmenityTicketPromo != null) ? data[i].AmenityTicketPromo : false,
						AmenityTubing:  (data[i].AmenityTubing != null) ? data[i].AmenityTubing : false,
						AmenityWarmingShelterLodge:  (data[i].AmenityWarmingShelterLodge != null) ? data[i].AmenityWarmingShelterLodge : false,
						ID: data[i].ID,
						index: i,
						SnowBase: data[i].SnowBase,
						BikeType: (data[i].BikeType != null) ? data[i].BikeType : '',
						Condition: data[i].Condition,
						ConditionClass: BingMap.Map.getConditionBase(data[i].ConditionClass),
						ConditionStatus: conditionStatus,
						ConditionId: conditionId,
						County: data[i].County,
						DateModified: data[i].DateModified,
						FilterOpen: filterOpen,
						GroomedFor: groomedFor,
						HasNoReporter: data[i].HasNoReporter,
						HeaderImage: (data[i].HeaderImage != null) ? data[i].HeaderImage.FileLocationWithoutTilde : '',
						HeaderImageAltText: data[i].HeaderImageAltText,															
						IsDNRTrail: data[i].IsDNRTrail,
						IsIceAgeTrail: data[i].IsIceAgeTrail,
						Hours: (data[i].Hours != null) ? data[i].Hours : '',
						IsGroomed: data[i].IsGroomed,
						IsGroomedForClassicSkiing: (data[i].IsGroomedForClassicSkiing != null) ? data[i].IsGroomedForClassicSkiing : '',
						IsGroomedForFatBiking: (data[i].IsGroomedForFatBiking != null) ? data[i].IsGroomedForFatBiking : '',
						IsGroomedForSkateSkiing: (data[i].IsGroomedForSkateSkiing != null) ? data[i].IsGroomedForSkateSkiing : '',
						IsSkijoringAvailable: (data[i].IsSkijoringAvailable != null) ? data[i].IsSkijoringAvailable : '',
						IsSnowshoeingAvailable: (data[i].IsSnowshoeingAvailable != null) ? data[i].IsSnowshoeingAvailable : '',
						IsWinterFatBikingAvailable: (data[i].IsWinterFatBikingAvailable != null) ? data[i].IsWinterFatBikingAvailable : '',
						IsSnowMobile: data[i].IsSnowMobile,
						IsYoutubePin: isYoutubePin,
						Latitude: data[i].Latitude,
						Longitude: data[i].Longitude,
						LocationStatus: (data[i].LocationStatus != undefined && data[i].LocationStatus != null) ? data[i].LocationStatus : '',
						Runs: openRuns,
						Open: useOpen,
						//OpenWinterFatBiking: (data[i].OpenWinterFatBiking != null) ? data[i].OpenWinterFatBiking : '',
                        PercentToPeak: percentToPeak,
                        PercentToPeakStatus: percentToPeakStatus,
                        FallColor: fallColor,
						Rating: useRating,
						RelatedPlaces: data[i].RelatedPlaces,
						Region: data[i].Region,
						ReportType: reportType,
						Subcode: (reportSubcode != null) ? reportSubcode.toLowerCase() : '',
						SurfaceType: useSurfaceType,
						ParentRegion: data[i].ParentRegion,
						State: data[i].State,
						Title: data[i].Title,
						TotalRuns: (data[i].TotalRuns != null) ? data[i].TotalRuns : '',
						TrailType: useTrailType,
						TrailheadDirections: (data[i].TrailheadDirections != null) ? data[i].TrailheadDirections : '',
						TrailheadName: (data[i].TrailheadName != null) ? data[i].TrailheadName : '',
						WeeksToPeak: data[i].WeeksOfPeak,
						WeeksToPeakName: data[i].WeeksToPeakName,
						filterWeeksToPeak1: data[i].WeeksToPeak == 1 ? true : false,
						filterWeeksToPeak2: data[i].WeeksToPeak == 2 ? true : false,
						filterWeeksToPeak3: data[i].WeeksToPeak == 3 ? true : false,
						filterWeeksToPeak4: data[i].WeeksToPeak == 4 ? true : false,
						filterWeeksToPeak5: data[i].WeeksToPeak == 5 ? true : false,
						filterWeeksToPeak6: data[i].WeeksToPeak == 6 ? true : false,
						filterWeeksToPeak7: data[i].WeeksToPeak == 7 ? true : false,
						filterWeeksToPeak8: data[i].WeeksToPeak == 8 ? true : false,
						filterWeeksToPeak9: data[i].WeeksToPeak == 9 ? true : false,
						filterWeeksToPeak10: data[i].WeeksToPeak == 10 ? true : false,
						filterWeeksToPeak11: data[i].WeeksToPeak == 11 ? true : false,
						filterWeeksToPeak12: data[i].WeeksToPeak == 12 ? true : false
					};
					//if (_log) console.log('jsonContentBody:', jsonContentBody);
					htmlBody += compiledTemplateBody(jsonContentBody);
				}
			}

			//ADD REGION FOOTER, OL CLOSING TAG
			htmlBody += reportsOLCloseTemplate;
			//if (_log) console.log('htmlBody:', htmlBody);

			$('#reportsAll').append(htmlBody);

			tw.ConditionsReports.setPaneRecords();
			//console.log('addAllReportsByRegion repeater done.');
		}

		var reportType = tw.ConditionsReports.getReportType()
		if (reportType == reportTypeEnum.downhill) {
			//wait for map to initialize before adding icons
			var mapInt = setInterval(function () {
				var isReady = BingMap.Map.getMapInit();
				if (isReady != null) {
					clearInterval(mapInt);
					BingMap.Map.addDownhillIcons(data);
				}
			}, 200);
		}

		//if (_log) console.log('addAllReportsByRegion youtubeArr:', youtubeArr);
		// if(youtubeArr.length > 0) BingMap.Map.addYoutubePinLocations(youtubeArr);
		// if(relatedPlacesArr.length > 0) BingMap.Map.addRelatedPlacesLocations(relatedPlacesArr);
		

		// if (_log) console.groupEnd();

		//todo: this doesn't really fix the problem. 
		setTimeout(() => {
			console.log('addAllReportsByRegion.done.wait for timeout 600');

			if (reportType == reportTypeEnum.fallcolor) BingMap.Map.getYoutubePinLocations();
			if (reportType == reportTypeEnum.fallcolor) BingMap.Map.getPOIPinLocations();
			if (reportType == reportTypeEnum.trail) BingMap.Map.getTrailPOIPinLocations();
			if (reportType == reportTypeEnum.trail) BingMap.Map.getTrailYoutubePinLocations();

		}, 600);


	}



	var getGroomedFor = function (data) {
		var groomedFor = "";
		if(reportType == "crosscountry") {
			if(data.IsGroomedForSkateSkiing){
				groomedFor = "Skate Skiing";
			}
			if(data.IsGroomedForClassicSkiing){
				if(groomedFor != ""){
					groomedFor += ", ";
				}
				groomedFor += "Classic Skiing";
			}
			if(data.IsGroomedForFatBiking){
				if(groomedFor != ""){
					groomedFor += ", ";
				}
				groomedFor += "Winter Fat Biking";
			}
			if(groomedFor != "") {
				groomedFor = "Groomed for: " + groomedFor;
			} else {
				groomedFor = "Not groomed";
			}
		} else if(reportType == 'snowmobile') {
			groomedFor = data.Groomed ? data.Groomed : "";
		}
		
		return groomedFor;
	}

	
	/**
	 * Add Local Reports to pane
	 * @param {*} data 
	 */
	var addLocalReports = function (data, reportType) {
		// if (_log) console.group('addLocalReports()');
		// if (_log) console.log('data.length', data.length);
		if (_log) console.log('addLocalReports.data', data);
		// if (_log) console.log('reportType', reportType);

		if (data.length < 1) {
			if (_log) console.log('Empty reports');
			//empty report
			var compiledTemplate = Template7.compile(noReportsTemplate),
				html = compiledTemplate();

		} else {
			//regular reports

			//if (_log) console.log('Regular reports');

			var useTemplate;
			switch(reportType) {
				case reportTypeEnum.trail:
					useTemplate = reportsAllBodyTrailTemplate;
					break;
				case reportTypeEnum.fallcolor:
					useTemplate = reportsAllBodyFCRTemplate;
					break;
				default:
					useTemplate = reportsAllBodySCRTemplate;
			}

			var compiledTemplate = Template7.compile(useTemplate);

			// OL OPENER TAG, can't append() an opening tag without a closing tag
			var html = reportsOLOpenTemplate;

			for (var i = 0; i < data.length; i++) {
				//if (_log) console.log('data[' + i + '].LocationStatus: ', data[i].LocationStatus); 
				if (_log) console.log('-- data[' + i + '].State:', data[i].State , ': ', data[i].Title);
				
				var isYoutubePin = (data[i].State == strYoutubePin || data[i].Condition == strYoutubePin) ? true : false;
				data[i].IsYoutubePin = isYoutubePin;
 
				//used for toggle "status" button, status only exists for Snomobile tho, so use Condition instead
				var conditionStatus = '';
				if (reportType == reportTypeEnum.trail) {
					if(data[i].IsOpenWinterFatBiking) {
						conditionStatus = 'winterfat';
					} else {
						conditionStatus = (data[i].IsOpen) ? 'open' : 'closed';
					}
				} else if (reportType != reportTypeEnum.fallcolor) {
					conditionStatus = (data[i].Condition.toLowerCase() == 'closed') ? 'closed' : 'notclosed';
				}
				
				var openRuns = false;
				if (reportType === reportTypeEnum.downhill) {// && data[i].RunsOpen !== undefined
					openRuns = data[i].RunsOpen;
                }

                var fallColor = BingMap.Map.getFallColorClass(data[i].PercentToPeak);
				var percentToPeak = data[i].PercentToPeak;
				var percentToPeakStatus = percentToPeak + '%';
				if (data[i].PercentToPeak == 105) {
					percentToPeakStatus = 'Fading Peak';
				} else if (data[i].PercentToPeak == 110) {
					percentToPeakStatus = 'Until Next Year'
                }
				
				var useTrailType = '';
				if(data[i].TrailType && data[i].TrailType != '') {
					useTrailType = data[i].TrailType.split(',').join(', ');
				}

				var useSurfaceType = '';
				if(data[i].SurfaceType && data[i].SurfaceType != '') {
					useSurfaceType = data[i].SurfaceType.split(',').join(', ');
				}

				var useRating = '';
				if(data[i].Rating && data[i].Rating != '') {
					useRating = data[i].Rating.split(',').join(', ');
				}

				var useOpen = '';
				if(data[i].Open != null && data[i].Open != '') {
					useOpen = data[i].Open;
				}
				if(data[i].OpenWinterFatBiking != null && data[i].OpenWinterFatBiking != 'Not Open for Winter Fat Biking') {
					useOpen = data[i].OpenWinterFatBiking;
				}

				var groomedFor = getGroomedFor(data[i]);

				var jsonContent = {
					Alert: (data[i].Alert != null) ? data[i].Alert : '',
					ID: data[i].ID,
					index: i,
					SnowBase: data[i].SnowBase,
					BikeType: (data.BikeType != null) ? data.BikeType : '',
					Condition: data[i].Condition,
					ConditionClass: BingMap.Map.getConditionBase(data[i].ConditionClass),
					ConditionStatus: conditionStatus,
					County: data[i].County,
					DateModified: data[i].DateModified,
                    FallColor: fallColor,
					GroomedFor: groomedFor,
					HasNoReporter: data[i].HasNoReporter,
					IsDNRTrail: data[i].IsDNRTrail,
					IsIceAgeTrail: data[i].IsIceAgeTrail,
					HeaderImage: (data[i].HeaderImage != null) ? data[i].HeaderImage.FileLocationWithoutTilde : '',
					HeaderImageAltText: data[i].HeaderImageAltText,		
					HeaderImageAltText: data[i].HeaderImageAltText,			
					Hours: (data[i].Hours != null) ? data[i].Hours : '',
					IsGroomed: data[i].IsGroomed,
					IsGroomedForClassicSkiing: (data[i].IsGroomedForClassicSkiing != null) ? data[i].IsGroomedForClassicSkiing : '',
					IsGroomedForFatBiking: (data[i].IsGroomedForFatBiking != null) ? data[i].IsGroomedForFatBiking : '',
					IsGroomedForSkateSkiing: (data[i].IsGroomedForSkateSkiing != null) ? data[i].IsGroomedForSkateSkiing : '',
					IsSkijoringAvailable: (data[i].IsSkijoringAvailable != null) ? data[i].IsSkijoringAvailable : '',
					IsSnowshoeingAvailable: (data[i].IsSnowshoeingAvailable != null) ? data[i].IsSnowshoeingAvailable : '',
					IsWinterFatBikingAvailable: (data[i].IsWinterFatBikingAvailable != null) ? data[i].IsWinterFatBikingAvailable : '',
					IsSnowMobile: data[i].IsSnowMobile,
					Latitude: data[i].Latitude,
					Longitude: data[i].Longitude,
					LocationStatus: (data[i].LocationStatus != undefined && data[i].LocationStatus != null) ? data[i].LocationStatus : '',
					Runs: openRuns,
					PercentToPeak: percentToPeak,
					PercentToPeakStatus: percentToPeakStatus,
					Open: useOpen,
					//OpenWinterFatBiking: (data[i].OpenWinterFatBiking != null) ? data[i].OpenWinterFatBiking : '',
					FallColor: fallColor,
					Rating: useRating,
					Region: data[i].Region,
					RelatedPlaces: data[i].RelatedPlaces,
					ReportType: reportType,
					ParentRegion: data[i].ParentRegion,
					Runs: openRuns,
					State: data[i].State,
					Subcode: (reportSubcode != null) ? reportSubcode.toLowerCase() : '',
					SurfaceType: useSurfaceType,
					Title: data[i].Title,
					TrailType: useTrailType,
					TrailheadDirections: data[i].TrailheadDirections,
					TrailheadName: data[i].TrailheadName,
					TotalRuns: (data[i].TotalRuns != null) ? data[i].TotalRuns : '',
					WeeksToPeak: data[i].WeeksOfPeak,
					WeeksToPeakName: data[i].WeeksToPeakName
				};
				// console.log('jsonContentLocal:', jsonContent);
				if(!isYoutubePin) html += compiledTemplate(jsonContent);
			}

			//ADD REGION FOOTER, OL CLOSING TAG
			html += reportsOLCloseTemplate;
			//if (_log) console.log('html:', html);

			// if (_log) console.groupEnd();

		}

		$('#reportsLocal').html(html);

		tw.ConditionsReports.setPaneRecords('reports-local');

		var openId = BingMap.Map.getOpenId(); 

		//console.log('###############openId', openId);
		//if openId exists, we want to ONLY open the detail ID, not the local reports pane. that would get triggered in addPinReportsToLayer
		if (openId == "") { 
			showReportSubpane('reports-local');
		}

	}


	/**
	 * Toggle visibility of Reports based on filters and data attributes
	*/
	var toggleVisibleStatusReports = function (reportType) {
		if (_log) console.group('toggleVisibleStatusReports()', reportType);

		var selectorList = '';
		var searchFilter = $('.js-filter-search').data('search-filter');

		//look for any filters, if checked add to list
		$('.js-reports-filter, .js-reports-filter23').each(function () {
			var curFilter = $(this).data('filter'),
				isChecked = $(this).is(":checked");

			if (_log) console.log('curFilter', curFilter, isChecked);
			if(isChecked) {
				if(selectorList != '') selectorList += ", ";
				selectorList += "[data-filter-" + curFilter + "='false']";
				$(this).parent().addClass('active');
			} else {
				$(this).parent().removeClass('active');
			}
		});
		
		// if (_log) console.log('selectorList', selectorList);

		//toggle visibility on list items
		$('.js-region-list-item').each(function () {
			var $item = $(this);
			$item.removeClass('hidden');
			var text = tw.ConditionsReports.normalizeText($item.text());
			var matchesFilters = !selectorList || !$item.is(selectorList);

			var searchWords = (searchFilter || '').split(' ').filter(w => w);
			var matchesSearch = searchWords.every(word => text.includes(word));

			if (matchesSearch && matchesFilters) {
				$item.removeClass('hidden');
			} else {
				$item.addClass('hidden');
			}
		});

		$('.js-noreports').remove();//clear out no reports
		$('.js-region-list').each(function() {
			var hei = $(this).height();
			// if (_log) console.log( key + ": " + hei );
			if (hei < 10) {
				//region has no reports
				var compiledTemplate = Template7.compile(noReportsTemplate),
					html = compiledTemplate();
				$(this).after(html);//add no reports
			}
		});

		var addReportTypeForSCR = '';
		if (reportType != reportTypeEnum.fallcolor) {
			addReportTypeForSCR = ' - ' + tw.ConditionsReports.getReportTitle('gaShort')
		}


		//Data layer
		tw.Analytics.ga4(baseCategory, 'Toggle Click' + addReportTypeForSCR, 'Filter', 'oncheckboxtoggle');

		if (_log) console.groupEnd();
	}

	/**
	 * Toggle visibility of Reports based on filters and data attributes
	*/
	var sortVisibleStatusReports = function (reportType) {
		if (_log) console.group('sortVisibleStatusReports()', reportType);

		$('.js-reports-sort').each(function(){
			var curFilter = $(this).data('filter'),
				isChecked = $(this).is(":checked");
			if (_log) console.log('curFilter', curFilter, isChecked);
			
			if(isChecked){
				$(this).parent().addClass('active');

				$('.js-region-list').each(function () {
					var wrapper = $(this)[0];
					var items = [...wrapper.children];
					if (_log) console.log('items:', items);

					if (reportType == reportTypeEnum.fallcolor) {
						//if (_log) console.log('FCR sort');
						items = items
							.filter(a => a.dataset.percentToPeak <= 105)
							.sort((a, b) => b.dataset.percentToPeak - a.dataset.percentToPeak);

						var itemsAboveFadingPeak = items.filter(a => a.dataset.percentToPeak > 105);
						items.push(...itemsAboveFadingPeak);

					} else {
						//if (_log) console.log('SCR sort lowercase');
						items = items.sort((a, b) => b.dataset.conditionid - a.dataset.conditionid);
					}
		
					items.forEach(item => wrapper.append(item));
				})
			} else {
				$(this).parent().removeClass('active');

				$('.js-region-list').each(function () {
					var wrapper = $(this)[0];
					var items = [...wrapper.children];
					//if (_log) console.log('items-UN:', items);

					items.sort((a, b) => a.dataset.title.localeCompare(b.dataset.title));

					items.forEach(item => wrapper.append(item));
				})
			}

			var addReportTypeForSCR = '';
			if (reportType != reportTypeEnum.fallcolor) {
				addReportTypeForSCR = ' - ' + tw.ConditionsReports.getReportTitle('gaShort')
			}

			//Data layer
			tw.Analytics.ga4(baseCategory, 'Toggle Click' + addReportTypeForSCR, 'Sort', 'oncheckboxtoggle');
		})
		if (_log) console.groupEnd();
	}


	return {
		addAllReportsByRegion: addAllReportsByRegion,
		addLocationPhotoFromId: addLocationPhotoFromId,
		addLocalReports: addLocalReports,
		addReportDetails: addReportDetails,
		expandReports: expandReports,
		emptyReportDetails: emptyReportDetails,
		emptyLocalReports: emptyLocalReports,
        hideReports: hideReports,
		initializeUGC: initializeUGC,
        isStatusFiltered: isStatusFiltered,
		addWeatherCurrentNearby: addWeatherCurrentNearby,
		getWeatherCurrentNearby: getWeatherCurrentNearby,
		addWeatherForecastNearby: addWeatherForecastNearby,
		getWeatherForecastNearby: getWeatherForecastNearby,
		getLocationPhotoFromId: getLocationPhotoFromId,
		getAllReportsByRegion: getAllReportsByRegion,
		getReportDetails: getReportDetails,
		showReports: showReports,
		showAllReports: showAllReports,
		showReportSubpane: showReportSubpane,
		toggleVisibleStatusReports: toggleVisibleStatusReports,
		sortVisibleStatusReports: sortVisibleStatusReports
	}
}());